<table-list [resource]="acessoPessoalResource" [service]="acessoPessoalService"></table-list>
